/*
 * @Author: 陈大仙人
 * @Date: 2020-09-22 17:15:30
 * @LastEditors: 陈大仙人
 * @LastEditTime: 2025-02-28 14:49:24
 * @FilePath: /akx-pc-main/src/util/http.js
 */
import axios from 'axios'
const config = require('../config.js')
import 'url-search-params-polyfill'
import { Message } from 'element-ui';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

/**
 * 判断是请求是否要走本地代理服务器
 * 解决跨域问题
 * 开发中使用
*/
if(process.env.VUE_APP_PROXY) {
  axios.defaults.baseURL = '/api'
}else {
  axios.defaults.baseURL = config.baseURL;
}
let Http = function(options, method = 'get') {

  // do something
  method = options.method || method;
  let params = '';
  let _Params = new URLSearchParams(options.params || {});
  let urlSearch = [];
  if(method === 'post') {
    params = _Params;
  } else {
    params = _Params.toString();
    params && urlSearch.push(params);
  }
  urlSearch[0] && (options.url = `${options.url}?${urlSearch.join('&')}`);
  return axios({
    method,
    headers: options.headers || '',
    url: options.url,
    data: params,
    withCredentials: options.url === '/employee/register' ? false : true,
  }).then(res => {
    if(res.data.code === 0) {
      options.success && options.success(res.data);
    }else {
      options.fail && options.fail(res.data);
      if(res.data.msg.indexOf('LOGIN') !== -1 || res.data.msg.indexOf('LOSE_AUTH') !== -1) {
        options.redirect !== false && replaceLogin()
      }else if(options.failTip !== false) {
        if(res.data.msg && res.data.msg.indexOf('API检索失败') === -1) {
          Message.warning({
            message: res.data.msg
          })
        }
      }
    }
  }).catch(res => {
    options.fail && options.fail(res.data);
    Message.warning({
      message: res.msg
    })
  }).finally(res => {
    options.complete && options.complete(res)
  })
}
Http.get = function(options) {
  return Http(options, 'get')
}

Http.post = function(options) {
  return Http(options, 'post')
}

function replaceLogin() {
  let pathname;
  if(location.pathname.indexOf('index.html') !== -1) {
    pathname = location.pathname.replace('index.html', 'login.html')
  }else {
    pathname = location.pathname + 'login'
  }
  let url = location.origin + pathname + '?RETURN_URL=' + location.hash.replace('#', '');
  location.replace(url)
}
export default Http;
